import React from 'react'
import { Link } from 'react-router-dom'
import { AttendeeStack } from '../../../components'
import { appName } from '../appConfig'
import { useAddToCalendar } from '../../../hooks'
import { icsFromEvent } from '../helpers/ics'

const formatDateTime = (iso) => {
  if (!iso) return ''
  const d = new Date(iso)
  const date = d.toLocaleDateString('sv-SE', { day: 'numeric', month: 'short' })
  const time = d.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' })
  return `${date}, ${time}`
}

// The single standardised compact-row renderer, shared by the full /events
// list page and the global docked ActivityWidget — one component, one format,
// wherever an event shows up.
export const EventListItem = ({ event, onToggleInterest }) => {
  const { offerAddToCalendar } = useAddToCalendar()

  // Marking yourself interested (not un-marking) offers an .ics download —
  // onToggleInterest resolves the toggle API response, so we can tell
  // whether this click just turned interest on.
  const handleToggleInterest = async () => {
    const res = await onToggleInterest(event.event_slug)
    if (res && res.user_has_marked_interest) offerAddToCalendar(icsFromEvent(event))
  }

  return (
    <div className="ev-list-item">
      {/* Targets the event's detail page, not /edit — the detail page is where both the
          guest list and the edit button live. This row is shared with the landing page's
          ActivityWidget, where dropping someone straight into an edit form was odd. */}
      <Link to={`/${appName}/${event.event_slug}`} className="ev-list-item-main">
        <div className="ev-list-item-date">
          <span className="ev-list-item-datetime">{formatDateTime(event.event_start_timestamp)}</span>
          {event.sourceLabel && <span className="ev-list-item-source"> · {event.sourceLabel}</span>}
        </div>
        <div className="ev-list-item-title-row">
          <span className="ev-list-item-title">{event.event_title}</span>
          {event.event_type &&
            <span className={"pill " + (event.event_type === 'internal' ? "ev-pill-internal" : "ev-pill-external")}>
              {event.event_type === 'internal' ? 'Internt' : 'Externt'}
            </span>
          }
        </div>
        {event.event_location && <div className="ev-list-item-location">{event.event_location}</div>}
      </Link>

      <div className="ev-list-item-actions">
        {/* External guest list, when the event has one. Rendered only when non-zero so
            calendar-only events (and every event in the widget before guests exist) look
            exactly as they did before. */}
        {event.event_guest_count > 0 &&
          <span className="ev-list-item-guests" title="Gäster · svarat ja">
            {event.event_guest_count} gäst{event.event_guest_count > 1 ? 'er' : ''}
            {event.response_yes_count > 0 && <span className="ev-list-item-guests-yes"> · {event.response_yes_count} ja</span>}
          </span>
        }
        {event.event_url &&
          <a className="ev-list-item-link" href={event.event_url} target="_blank" rel="noreferrer">Länk ↗</a>
        }
        <AttendeeStack
          users={event.interested_users || []}
          isParticipant={event.user_has_marked_interest}
          onToggle={handleToggleInterest}
          joinTitle="Markera intresse"
          leaveTitle="Ta bort intresse"
        />
      </div>
    </div>
  )
}
